import script from "./RcButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcButton.vue?vue&type=script&setup=true&lang=ts"

import "./RcButton.vue?vue&type=style&index=0&id=96b74df4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96b74df4"]])

export default __exports__